import { CompanySections, defaultCompanyContent } from "@quintara/site-kit";
import { usePageMeta } from "../usePageMeta";
import { useCmsContent } from "../useCmsContent";

export function Company() {
  const content = useCmsContent("company", defaultCompanyContent);
  usePageMeta(content.meta.title, content.meta.description);
  return <CompanySections content={content} />;
}
